import { createSelector } from '@reduxjs/toolkit';
import { firebaseSelector, firebaseLoggedInSelector, firebaseScaffoldedSelector } from '..';

export const hasFirebaseInstance = createSelector(firebaseSelector, (firebase) => !!firebase);

export const hasFirebaseAuth = createSelector(firebaseLoggedInSelector, (firebaseLoggedIn) => !!firebaseLoggedIn);

export const hasFirebaseScaffolded = createSelector(firebaseScaffoldedSelector, (firebaseScaffolded) => !!firebaseScaffolded);
